export default "__VITE_ASSET__823b18a3__"